<template>
  <header class="aff-header">
    <div class="menu-mobile" @click="OpenAppDrawer">
      <svg viewBox="0 0 24 16">
        <g
          transform="translate(-16.000000, -20.000000)"
          fill-rule="nonzero"
          fill="#E9ECFF"
        >
          <g id="Icons/Hamburger" transform="translate(10.000000, 10.000000)">
            <path
              d="M20,19 L7,19 C6.4,19 6,18.6 6,18 C6,17.4 6.4,17 7,17 L20,17 C20.6,17 21,17.4 21,18 C21,18.6 20.6,19 20,19 Z M29,12 L7,12 C6.4,12 6,11.6 6,11 C6,10.4 6.4,10 7,10 L29,10 C29.6,10 30,10.4 30,11 C30,11.6 29.6,12 29,12 Z M29,26 L7,26 C6.4,26 6,25.6 6,25 C6,24.4 6.4,24 7,24 L29,24 C29.6,24 30,24.4 30,25 C30,25.6 29.6,26 29,26 Z"
              id="Menu"
            />
          </g>
        </g>
      </svg>
    </div>
    <div class="aff-header-left">
      <router-link :to="{ name: 'Root' }" class="aff-header-left--logo">
        <svg
          width="129"
          height="28"
          viewBox="0 0 129 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M31.7303 7.81506C35.0658 7.81506 37.8551 10.1548 38.4793 13.4787H36.1581C35.5729 11.5106 33.8369 10.2423 31.7888 10.2423C29.019 10.2423 27.0684 12.4946 27.0684 15.731C27.0684 18.9892 28.98 21.2415 31.7888 21.2415C33.9539 21.2415 35.729 19.8639 36.2361 17.7865H31.3792V15.6216H38.6743C38.6158 20.3012 35.7875 23.6687 31.7888 23.6687C27.7706 23.6687 24.7863 20.3231 24.7863 15.731C24.7863 11.1826 27.7316 7.81506 31.7303 7.81506Z"
            fill="white"
          />
          <path
            d="M39.864 17.4803C39.864 13.9378 42.2047 11.2919 45.2866 11.2919C48.505 11.2919 50.6507 14.069 50.6507 17.5021C50.6507 17.7645 50.6312 18.0488 50.6117 18.3112H42.0682C42.3217 20.2137 43.5506 21.3945 45.2866 21.3945C46.535 21.3945 47.5688 20.7385 48.1149 19.667H50.3971C49.5584 22.1598 47.6273 23.6687 45.2866 23.6687C42.2047 23.6687 39.864 21.0009 39.864 17.4803ZM48.4855 16.3432C48.0954 14.5501 46.8861 13.4786 45.2866 13.4786C43.6481 13.4786 42.4778 14.5719 42.1072 16.3432H48.4855Z"
            fill="white"
          />
          <path
            d="M52.5623 23.3844V11.5761H54.1032L54.4738 13.1068C55.254 11.9916 56.4634 11.3137 57.7508 11.3137C59.1747 11.3137 60.306 12.1009 60.9107 13.3692C61.6714 12.1009 62.9588 11.3137 64.3437 11.3137C66.5674 11.3137 68.0693 13.1943 68.0693 15.884V23.3844H65.9042V16.4744C65.9042 14.5719 65.1629 13.4786 63.8561 13.4786C62.4516 13.4786 61.3788 14.9218 61.3788 16.9336V23.3844H59.2527V16.4744C59.2527 14.5719 58.531 13.4786 57.2046 13.4786C55.8002 13.4786 54.7274 14.9218 54.7274 16.9336V23.3844H52.5623Z"
            fill="white"
          />
          <path
            d="M70.8 23.3844V8.07739H75.852C78.4853 8.07739 80.4944 10.2204 80.4944 13.1287C80.4944 16.0152 78.5048 18.18 75.852 18.18H73.0432V23.3844H70.8ZM73.0432 15.7965H75.735C77.1979 15.7965 78.2317 14.6813 78.2317 13.1287C78.2317 11.598 77.1979 10.4609 75.735 10.4609H73.0432V15.7965Z"
            fill="white"
          />
          <path
            d="M81.4307 17.4803C81.4307 13.9159 83.7909 11.2919 86.9313 11.2919C88.4722 11.2919 89.8181 11.9479 90.7739 13.0412L91.0275 11.5761H92.705V23.3844H90.9495L90.7349 21.9412C89.7791 23.0345 88.4527 23.6687 86.9313 23.6687C83.7909 23.6687 81.4307 21.0228 81.4307 17.4803ZM83.6348 17.4803C83.6348 19.6889 85.1172 21.3508 87.0873 21.3508C89.0769 21.3508 90.5203 19.7107 90.5203 17.4803C90.5203 15.2498 89.0769 13.6098 87.0873 13.6098C85.1172 13.6098 83.6348 15.2717 83.6348 17.4803Z"
            fill="white"
          />
          <path
            d="M94.6166 17.1741C94.6166 13.8722 96.8987 11.2919 99.8246 11.2919C101.366 11.2919 102.731 11.9698 103.667 13.1068L104.018 11.5761H105.442V21.8318C105.442 25.6149 103.433 27.9109 100.176 27.9109C97.4839 27.9109 95.5724 26.3365 95.0262 23.7343H97.1913C97.601 25.0463 98.8298 25.7461 100.156 25.7461C101.99 25.7461 103.316 24.4122 103.316 22.1598V21.635C102.399 22.5097 101.19 23.0345 99.8246 23.0345C96.8987 23.0345 94.6166 20.4761 94.6166 17.1741ZM96.8207 17.1741C96.8207 19.2296 98.2056 20.7822 100.078 20.7822C101.951 20.7822 103.316 19.2515 103.316 17.1741C103.316 15.0749 101.951 13.5442 100.078 13.5442C98.2056 13.5442 96.8207 15.0968 96.8207 17.1741Z"
            fill="white"
          />
          <path
            d="M107.354 17.4803C107.354 13.9378 109.695 11.2919 112.776 11.2919C115.995 11.2919 118.141 14.069 118.141 17.5021C118.141 17.7645 118.121 18.0488 118.102 18.3112H109.558C109.812 20.2137 111.04 21.3945 112.776 21.3945C114.025 21.3945 115.059 20.7385 115.605 19.667H117.887C117.048 22.1598 115.117 23.6687 112.776 23.6687C109.695 23.6687 107.354 21.0009 107.354 17.4803ZM115.975 16.3432C115.585 14.5501 114.376 13.4786 112.776 13.4786C111.138 13.4786 109.968 14.5719 109.597 16.3432H115.975Z"
            fill="white"
          />
          <path
            d="M121.378 19.6451C121.437 20.8916 122.373 21.5257 123.641 21.5257C124.792 21.5257 125.689 20.979 125.689 19.995C125.689 18.8798 124.558 18.6174 123.271 18.3768C121.515 18.0488 119.447 17.5896 119.447 14.8562C119.447 12.7351 121.086 11.2919 123.524 11.2919C125.982 11.2919 127.562 12.7788 127.601 15.0749H125.553C125.514 13.9378 124.753 13.3474 123.485 13.3474C122.276 13.3474 121.534 13.9159 121.534 14.7687C121.534 15.8184 122.627 16.037 123.895 16.2557C125.67 16.6056 127.835 16.9773 127.835 19.8857C127.835 22.1817 126.118 23.6687 123.563 23.6687C120.988 23.6687 119.311 22.0942 119.252 19.6451H121.378Z"
            fill="white"
          />
          <path
            d="M22.3676 0.00847636L0.121304 7.81505C0.0335279 7.84785 -0.0152364 7.95719 0.00426927 8.06652L1.72077 14.3971C1.75003 14.4955 1.84756 14.5611 1.93533 14.5283L18.2519 8.79907C19.0321 8.52573 19.6855 7.91345 20.0659 7.09343C21.0802 4.90672 21.9189 2.63253 22.5626 0.270882C22.6211 0.095945 22.5041 -0.035258 22.3676 0.00847636Z"
            fill="white"
          />
          <path
            d="M17.0327 10.953L3.21292 15.7966C3.1349 15.8294 3.08614 15.9168 3.11539 16.0043L4.56857 21.3508C4.59783 21.4383 4.67585 21.493 4.74412 21.4602L13.5607 18.366C14.2239 18.1364 14.7701 17.6115 15.0919 16.9227C15.9502 15.075 16.6621 13.1506 17.1985 11.1607C17.2473 11.0295 17.14 10.9093 17.0327 10.953Z"
            fill="white"
          />
          <path
            d="M11.7759 20.7276L6.01193 22.7503C5.94366 22.7721 5.9144 22.8487 5.93391 22.9252L7.16277 27.4408C7.18228 27.5173 7.25055 27.5611 7.31882 27.5283L8.85001 26.9925C9.40593 26.7957 9.87406 26.3584 10.1471 25.7679C10.8786 24.2044 11.4735 22.5863 11.9319 20.8916C11.9612 20.7932 11.8734 20.6838 11.7759 20.7276Z"
            fill="white"
          />
        </svg>
      </router-link>
      <div class="aff-header-left--text">Partners</div>
    </div>

    <div class="aff-header-right" v-clickaway="closeDropdown">
      <div class="aff-account" @click="toggleDropdown()">
        <div class="aff-account-name">
          <span v-if="user">{{ user.firstName }} {{ user.lastName }}</span>
          <span v-else>Account</span>
        </div>
        <div class="aff-account-icon" :class="{ 'aff-active': activeDropdown }">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.13017 6.11716C4.30374 5.96095 4.58515 5.96095 4.75871 6.11716L8 9.03431L11.2413 6.11716C11.4149 5.96095 11.6963 5.96095 11.8698 6.11716C12.0434 6.27337 12.0434 6.52663 11.8698 6.68284L8.31427 9.88284C8.1407 10.0391 7.8593 10.0391 7.68573 9.88284L4.13017 6.68284C3.95661 6.52663 3.95661 6.27337 4.13017 6.11716Z"
              fill="#AAAAAA"
            />
          </svg>
        </div>
      </div>
      <div class="aff-account-dropdown" v-if="activeDropdown" v->
        <div class="aff-account-dropdown--item" @click="handleRedirectTo('Settings')">
          <div class="aff-account-dropdown--item-icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M9.99999 6.35626C7.98747 6.35626 6.356 7.98773 6.356 10.0003C6.356 12.0128 7.98747 13.6443 9.99999 13.6443C12.0125 13.6443 13.644 12.0128 13.644 10.0003C13.644 7.98773 12.0125 6.35626 9.99999 6.35626ZM7.606 10.0003C7.606 8.67809 8.67782 7.60626 9.99999 7.60626C11.3222 7.60626 12.394 8.67809 12.394 10.0003C12.394 11.3224 11.3222 12.3943 9.99999 12.3943C8.67782 12.3943 7.606 11.3224 7.606 10.0003Z" fill="currentColor"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8.15457 1.25488C7.85191 1.25488 7.59275 1.47174 7.53936 1.76964L7.17706 3.79152C6.75451 3.97809 6.3545 4.20523 5.98216 4.4679L3.98214 3.75183C3.69624 3.64947 3.37812 3.76743 3.22808 4.03146L1.40294 7.24313C1.2529 7.50716 1.31435 7.84082 1.54862 8.03406L3.12626 9.33544C3.10465 9.55444 3.09361 9.77633 3.09361 10.0006C3.09361 10.2248 3.10465 10.4466 3.12624 10.6655L1.54862 11.9668C1.31435 12.1601 1.2529 12.4937 1.40294 12.7578L3.22808 15.9694C3.37812 16.2335 3.69623 16.3514 3.98214 16.2491L5.98189 15.5331C6.35433 15.7959 6.75445 16.0231 7.17712 16.2097L7.53936 18.2313C7.59275 18.5292 7.85191 18.746 8.15457 18.746H11.8458C12.1484 18.746 12.4076 18.5292 12.461 18.2313L12.8233 16.2095C13.2458 16.0229 13.6458 15.7957 14.0181 15.533L16.0182 16.2491C16.3041 16.3514 16.6222 16.2335 16.7723 15.9694L18.5974 12.7578C18.7474 12.4937 18.686 12.1601 18.4517 11.9668L16.8737 10.6651C16.8952 10.4463 16.9063 10.2246 16.9063 10.0006C16.9063 9.77645 16.8952 9.55468 16.8736 9.3358L18.4517 8.03406C18.686 7.84082 18.7474 7.50716 18.5974 7.24313L16.7723 4.03146C16.6222 3.76743 16.3041 3.64947 16.0182 3.75183L14.0179 4.46802C13.6456 4.20541 13.2457 3.97831 12.8233 3.79174L12.461 1.76964C12.4076 1.47174 12.1484 1.25488 11.8458 1.25488H8.15457ZM8.34703 4.34928L8.67753 2.50488H11.3228L11.6533 4.34948C11.692 4.56538 11.8411 4.74519 12.046 4.82329C12.5848 5.02854 13.0836 5.31258 13.5279 5.661C13.6969 5.79353 13.9221 5.83002 14.1242 5.75763L15.945 5.10574L17.2511 7.40404L15.8131 8.59024C15.6433 8.73034 15.5597 8.94945 15.593 9.16707C15.6346 9.43861 15.6563 9.71692 15.6563 10.0006C15.6563 10.2842 15.6346 10.5624 15.593 10.8339C15.5597 11.0515 15.6433 11.2706 15.8131 11.4107L17.2511 12.5969L15.945 14.8952L14.1245 14.2434C13.9223 14.171 13.6971 14.2075 13.5281 14.34C13.0838 14.6885 12.5848 14.9726 12.046 15.1779C11.841 15.256 11.692 15.4358 11.6533 15.6517L11.3228 17.496H8.67753L8.34708 15.6519C8.30839 15.436 8.15933 15.2562 7.95434 15.1781C7.41536 14.9728 6.91633 14.6887 6.47191 14.3401C6.30292 14.2076 6.07772 14.1711 5.87552 14.2435L4.05533 14.8952L2.74924 12.5969L4.18679 11.411C4.35663 11.2709 4.44023 11.0518 4.40687 10.8342C4.36524 10.5626 4.34361 10.2843 4.34361 10.0006C4.34361 9.71681 4.36525 9.4384 4.4069 9.16676C4.44027 8.94913 4.35667 8.73 4.18683 8.5899L2.74924 7.40404L4.05533 5.10574L5.87577 5.75751C6.07795 5.8299 6.30314 5.79342 6.47212 5.6609C6.91648 5.31243 7.41542 5.02836 7.95429 4.82311C8.15928 4.74503 8.30834 4.5652 8.34703 4.34928Z" fill="currentColor"/>
            </svg>
          </div>
          <div class="aff-account-dropdown--item-text">
            Settings
          </div>
        </div>
        <div class="aff-account-dropdown--item" @click="handleRedirectTo('SignOut')">
            <div class="aff-account-dropdown--item-icon">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.6106 3.54175C10.6106 3.19657 10.3308 2.91675 9.9856 2.91675C9.64042 2.91675 9.3606 3.19657 9.3606 3.54175V9.65152C9.3606 9.9967 9.64042 10.2765 9.9856 10.2765C10.3308 10.2765 10.6106 9.9967 10.6106 9.65152V3.54175ZM6.02276 6.22856C6.26684 5.98449 6.26684 5.58876 6.02277 5.34468C5.77869 5.1006 5.38296 5.1006 5.13888 5.34468C4.1774 6.30615 3.52263 7.53114 3.25735 8.86474C2.99208 10.1983 3.12822 11.5807 3.64856 12.8369C4.1689 14.0931 5.05008 15.1668 6.18065 15.9223C7.31122 16.6777 8.64042 17.0809 10.0002 17.0809C11.3599 17.0809 12.6891 16.6777 13.8197 15.9223C14.9502 15.1669 15.8314 14.0931 16.3518 12.8369C16.8721 11.5807 17.0083 10.1984 16.743 8.86477C16.4777 7.53117 15.8229 6.30617 14.8615 5.3447C14.6174 5.10062 14.2217 5.10062 13.9776 5.3447C13.7335 5.58877 13.7335 5.9845 13.9776 6.22858C14.7642 7.01524 15.3 8.01751 15.517 9.10863C15.734 10.1998 15.6226 11.3307 15.1969 12.3586C14.7712 13.3864 14.0502 14.2649 13.1252 14.883C12.2002 15.501 11.1127 15.8309 10.0002 15.8309C8.88765 15.8309 7.80013 15.501 6.87512 14.8829C5.9501 14.2649 5.22915 13.3864 4.80341 12.3585C4.37768 11.3307 4.26629 10.1997 4.48333 9.10861C4.70038 8.01748 5.2361 7.01522 6.02276 6.22856Z" fill="currentColor"/>
              </svg>
            </div>
            <div class="aff-account-dropdown--item-text">
              Sign Out
            </div>
          </div
        >
      </div>
    </div>
  </header>
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";
import Intercom from "@/utils/intercom.js";
import Cookie from "@/utils/cookie.js";
export default {
  name: "Menu",
  data() {
    return {
      interval: null,
      activeDropdown: false,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.info,
    }),
  },
  methods: {
    ...mapMutations({
      OpenAppDrawer: "OpenAppDrawer",
    }),
    ...mapActions({
      doLogin: "userSignin",
    }),
    toggleDropdown() {
      this.activeDropdown = !this.activeDropdown;
    },
    closeDropdown() {
      this.activeDropdown = false;
    },
    handleRedirectTo(to) {
      this.activeDropdown = false;
      this.$router.push({ name: to });
    }
  },
  created() {
    if (!this.user) {
      this.doLogin({
        token: Cookie.get(Cookie.key),
        onSuccess: () => {
          clearInterval(this.interval);
          Intercom.setIntercomUser(this.user);

          this.interval = setInterval(() => {
            if (window.dataLayer) {
              window.dataLayer.push({
                __id_partner: this.user.id,
              });
              clearInterval(this.interval);
            }
          }, 1000);
        },
      });
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/sass/media_queries.scss";
@import "../assets/sass/modules/_color.scss";

.aff-header {
  position: fixed;
  width: 100%;
  background: #151617;
  display: flex;
  align-items: center;
  padding: 0 24px;

  @include laptop {
    padding: 0 15px;
  }

  @include phone {
    padding-left: 15px;
    padding-right: 15px;
  }

  @include phone-tiny {
    padding-left: 15px;
    padding-right: 15px;
  }

  &-left {
    display: flex;
    align-items: center;

    &--logo {
      display: flex;
      border-right: 1px solid #5b5b5b;
      padding-right: 8px;
    }

    &--text {
      margin-left: 8px;
      font-family: "Poppins";
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 150%;
      color: #d6d6d6;
    }

    @include laptop {
      display: none;
    }

  }

  &-right {
    position: relative;
    margin-left: auto;
    padding: 18px 0;

    .aff-account {
      display: flex;
      align-items: center;
      cursor: pointer;

      &-name {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 150%;
        color: #FFFFFF;
      }

      &-icon {
        padding: 4px;
        margin-left: 8px;
        display: flex;

        svg {
          transform: rotate(180deg);
        }

        &.aff-active {
          svg {
            transform: rotate(0deg);
          }
        }
      }

      &-dropdown {
        position: absolute;
        background: #424242;
        right: -16px;
        top: calc(100% + 8px);
        border-radius: 0 0 3px 3px;

        @include laptop {
          right: 0;
        }

        &::before {
          content: "";
          width: 0;
          height: 0;
          border-left: 8px solid transparent;
          border-right: 8px solid transparent;
          border-bottom: 8px solid #424242;
          position: absolute;
          left: 50%;
          top: -8px;
        }

        &--item {
          cursor: pointer;
          padding: 0 24px;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #525252;
          width: 250px;
          height: 50px;

          @include laptop {
            width: 220px;
          }



          &:last-child {
            border-bottom: unset;
            border-radius: 0 0 3px 3px;
          }

          &-icon {
            margin-right: 16px;
            display: flex;
            color: #E2E2E2;


          }

          &-text {
            font-family: 'Inter';
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 16px;
            color: #A6A6A6;
          }

          &:hover {
            background: #333333;

            .aff-account-dropdown--item-icon,
            .aff-account-dropdown--item-text {
              color: #E2E2E2;
            }
          }
        }
      }
    }
  }

  .menu-mobile {
    height: 60px;
    position: relative;
    cursor: pointer;
    display: none;

    svg {
      width: 27px;
      fill: #fdfdfd;
    }

    @include laptop {
      display: flex;
    }
  }

}
</style>
